<template>
  <modal name="wordCloud.importText"
    transition="nice-modal-fade"
    :width="422"
    :height="'auto'"
    :classes="['custom']"
    :clickToClose="false"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="container" @keydown.stop>
      <div class="header">导入文本</div>
      <div class="content">
        <div class="text">
          您可以在下方文本框
          <a @click="report()" class="link" :href="$getWikiLink('https://wiki.laihua.com/basic/wenziyun/wenziyun.html')" target="_blank">参照格式</a>
          输入多行文本数据
        </div>
        <div class="text" style="margin-bottom: 1.5em;">设置文本参数：</div>
        <textarea
          @focus="onFocus"
          style="textAlign: left;"
          name="" id="" cols="30" rows="10"
          v-model="input"
          ref="textarea"
        ></textarea>
      </div>
      <div class="hr"></div>
      <div class="footer">
        <div class="btn intereact-blue" @click="send">添加文本</div>
        <div class="btn outline intereact-grey" @click="hide">取消</div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      input: '来画；10；\n视频；8；\n前海；1；\n手绘；1；',
      defInput: '来画；10；\n视频；8；\n前海；1；\n手绘；1；',
    }
  },
  methods: {
    beforeOpen () {
      this.$bus.emit('FeaturesPop_close_vue', {
        type: 3,
      });
      this.$bus.emit('wordCloud.hidePopups');
      // this.input = this.defInput
    },
    closed () {
      this.input = '';
    },
    parse () {
      let list = [];
      let arr = this.input.replace(/\n/g, '').replace(/[;；]$/, '').split(/;|；/);
      arr.forEach((item, i) => {
        let trimed = (item || '').trim();
        if (i % 2 === 0) {
          let size = arr[i+1] | 0;
          if (!size) {
            size = 1;
          }
          if (size < 1) {
            size = 1
          } else if (size > 10) {
            size = 10
          }
          trimed && list.push({
            text: trimed,
            size: size
          });
        }
      });

      return list;
    },
    send () {
      let list = this.parse();
      if (list.length) {
        this.$bus.emit('wordCloud.sendImportText', list);
        this.hide();
      } else {
        this.$refs.textarea.focus();
      }
    },
    hide () {
      this.$modal.hide('wordCloud.importText');
    },
    onFocus () {
      // this.$refs.textarea.select();
    },
    report () {
      this.$analysis('word_cloud,click_text_import_wiki，文字云_点击_导入文本_wiki')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  & * {
    color: #474261;
  }
  height: 100%;
  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
  background-color: #fff;

  & * {
    text-align: center;
  }
}
.header {
  width: 422px;
	height: 40px;
	line-height: 40px;
  padding-left: 1em;
	background-color: #d9ddea;
	border-radius: 8px 8px 0 0;
  text-align: left;
}
.content {
  padding-top: 1.2em;
}
.text {
  text-align: left;
  font-size: 14px;
  color: #474261;
  padding-left: 1em;
  margin-bottom: 0.6em;
}
textarea {
  width: 396px;
	height: 364px;
	background-color: #ffffff;
	border: solid 1px #d9ddea;
  padding: 1em;
  resize: none;
  line-height: 1.8;
}
.hr {
  width: 396px;
	height: 2px;
	background-color: #f0f0f8;
  margin: auto;
  margin-top: 45px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 72px;
  padding-right: 1em;
}
.btn {
  width: 100px;
	height: 34px;
  line-height: 34px;
	background-color: #5778fb;
	border-radius: 4px;
  margin-left: 0.8em;
  color: #fff;
  text-align: center;

  &.outline {
    background-color: #f4f4f8;
    border: solid 1px #d9ddea;
    color: #474261;
  }
}

.link {
  color: #5778fb;
  &:visited {
    color: #5778fb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/modals/importText.vue